const validTenantLocalities = ['us', 'ca', 'eu', 'au', 'pus2', 'jp', 'uk', 'sus', 'tus\\d?-?\\d?'];
if (window.scConfig.NODE_ENV === 'development') {
  validTenantLocalities.push('local');
}
export const tenantIdRegex = new RegExp(`^[a-zA-Z0-9][-a-zA-Z0-9]{1,62}[a-zA-Z0-9]@(${validTenantLocalities.join("|")})$`);
